import { useCallback, useState } from 'react';
function useForceUpdate() {
  const [, setForceUpdate] = useState(0);
  return useCallback(() => setForceUpdate(s => s + 1), [setForceUpdate]);
}
export default useForceUpdate;